import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

const styles = css`
  .AccessibilityLink {
      left:-999px;
      position: fixed;
      top:auto;
      width:1px;
      height:1px;
      overflow:hidden;
      z-index:-999;
      &:focus, &:active {
        color:${colors.white};
        background-color:${colors.body};
        left: auto;
        top: auto;
        width: 30%;
        height: auto;
        overflow:auto;
        margin:10px 35%;
        padding:5px;
        border-radius:0;
        border:4px solid ${colors.brand1};
        text-align:center;
        font-size:1.2em;
        z-index:999;
      }
  }
`;

function AccessibilityLinks() {
  return (
    <div className={styles} >
      <a className="AccessibilityLink" href="#mainContent">Skip To Main Content</a>
      <Link className="AccessibilityLink" name="accessibility">Accessibility Help & Feedback</Link>
    </div>
  );
}

AccessibilityLinks.propTypes = {
  builder: PropTypes.object.isRequired,
  agent: PropTypes.object,
};

AccessibilityLinks.defaultProps = {
  agent: undefined,
};

export default withData(
  {
    builder: true,
    agent: true,
  },
)(AccessibilityLinks);



// WEBPACK FOOTER //
// ./src/components/Header/AccessibilityLinks.js